const LOGIN_FORM = function () {
  return 'login-form';
};

const SIGN_UP_CREATE_ACCOUNT = function () {
  return 'sign-up-create-account';
};

const SIGN_UP_BUSINESS_INFO = function () {
  return 'sign-up-business-info';
};

const SIGN_UP_PAYMENT_INFO = function () {
  return 'sign-up-payment-info';
};

const SIGN_UP_EXTRA_INFO = function () {
  return 'sign-up-extra-info';
};

const BOOK_A_CALL = function () {
  return 'book-a-call';
};

const AFTER_SIGNUP = function () {
  return 'after-signup';
};

const SEND_YOUR_PHONE = function () {
  return 'send-your-phone';
};

const SIGN_UP_COACH_INFO = function () {
  return 'sign-up-coach-info';
};

const SIGN_UP_BUILD_SELECTION = function () {
  return 'sign-up-build-selection';
};

const SIGN_UP_DOWNLOAD_APP = function () {
  return 'sign-up-download-app';
};

const BUNDLE_SIGNUP_DETAILS = function () {
  return 'bundle-signup-details';
};

const BUNDLE_SIGNUP_BILLING = function () {
  return 'bundle-signup-billing';
};

export default {
  LOGIN_FORM,
  SIGN_UP_CREATE_ACCOUNT,
  SIGN_UP_BUSINESS_INFO,
  SIGN_UP_PAYMENT_INFO,
  SIGN_UP_EXTRA_INFO,
  BOOK_A_CALL,
  SEND_YOUR_PHONE,
  AFTER_SIGNUP,
  SIGN_UP_COACH_INFO,
  SIGN_UP_BUILD_SELECTION,
  SIGN_UP_DOWNLOAD_APP,
  BUNDLE_SIGNUP_DETAILS,
  BUNDLE_SIGNUP_BILLING,
};
